<template>
  <b-card
    v-if="data"
    class="card-browser-states"
  >
    <b-card-title class="mb-0">
      {{ title }}
    </b-card-title>
    <b-card-body>
      <div
        v-for="item in data"
        :key="item.id"
        class="browser-states"
      >
        <span class="align-self-center my-auto">
          {{ item.title }}
        </span>
        <div class="d-flex align-items-center">
          <strong class="text-body-heading mr-1">{{
            item.count
          }}</strong>
          <vue-apex-charts
            :options="radialBar.options"
            :series="item.series"
            type="radialBar"
            height="30"
            width="30"
          />
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'

export default {
  components: {
    VueApexCharts,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      radialBar: {
        series: [],
        options: {
          grid: {
            show: false,
            padding: {
              left: -15,
              right: -15,
              top: -12,
              bottom: -15,
            },
          },
          colors: [$themeColors.primary, $themeColors.warning],
          plotOptions: {
            radialBar: {
              hollow: {
                size: '25%',
              },
              track: {
                background: '#ebe9f1',
                strokeWidth: '70%',
              },
              dataLabels: {
                showOn: 'always',
                name: {
                  show: false,
                },
                value: {
                  show: false,
                },
              },
            },
          },
          stroke: {
            lineCap: 'round',
          },
        },
      },
    }
  },
}
</script>
